
<template>
  <div>
    <!-- <div v-if="!topdown" v-bind:class="{ hgrad: proportional, hgradf: !proportional }">
      <div class="wi" v-bind:class="{ fs: smallFont, fl: !smallFont, pw1: proportional, pwf: !proportional }"></div>
      <div class="wi" v-bind:class="{ fs: smallFont, fl: !smallFont, pw2: proportional, pwf: !proportional }"></div>
      <div class="wi" v-bind:class="{ fs: smallFont, fl: !smallFont, pw3: proportional, pwf: !proportional }"></div>
      <div class="wi" v-bind:class="{ fs: smallFont, fl: !smallFont, pw4: proportional, pwf: !proportional }"></div>
      <div class="wi" v-bind:class="{ fs: smallFont, fl: !smallFont, pw5: proportional, pwf: !proportional }"></div>
    </div>
    <div v-if="topdown" v-bind:class="{ vgrad: proportional, vgradf: !proportional }">
      <div class="hi" v-bind:class="{ fs: smallFont, fl: !smallFont, ph5: proportional, phf: !proportional }"></div>
      <div class="hi" v-bind:class="{ fs: smallFont, fl: !smallFont, ph4: proportional, phf: !proportional }"></div>
      <div class="hi" v-bind:class="{ fs: smallFont, fl: !smallFont, ph3: proportional, phf: !proportional }"></div>
      <div class="hi" v-bind:class="{ fs: smallFont, fl: !smallFont, ph2: proportional, phf: !proportional }"></div>
      <div class="hi" v-bind:class="{ fs: smallFont, fl: !smallFont, ph1: proportional, phf: !proportional }"
           v-b-tooltip.hover.nofade="toolTipDelay"
           title="0-34% $t('Webportal.Porsche.Unacceptable')"></div>
    </div> -->
    <div v-if="!topdown" v-bind:class="{ hgrad: proportional, hgradf: !proportional }">
      <div  class="wi"
            v-bind:class="{ fs: smallFont, fl: !smallFont, pw1: proportional, pwf: !proportional }"
            v-b-tooltip.hover.nofade="toolTipDelay"
            :title="tooltipText(0)">{{ displayTextConditional(0) }}</div>
      <div  class="wi" v-bind:class="{ fs: smallFont, fl: !smallFont, pw2: proportional, pwf: !proportional }"
            v-b-tooltip.hover.nofade="toolTipDelay"
            :title="tooltipText(1)">{{ displayTextConditional(1) }}</div>
      <div  class="wi" v-bind:class="{ fs: smallFont, fl: !smallFont, pw3: proportional, pwf: !proportional }"
            v-b-tooltip.hover.nofade="toolTipDelay"
            :title="tooltipText(2)">{{ displayTextConditional(2) }}</div>
      <div  class="wi"
            v-bind:class="{ fs: smallFont, fl: !smallFont, pw4: proportional, pwf: !proportional }"
            v-b-tooltip.hover.nofade="toolTipDelay"
            :title="tooltipText(3)">{{ displayTextConditional(3) }}</div>
      <div  class="wi"
            v-bind:class="{ fs: smallFont, fl: !smallFont, pw5: proportional, pwf: !proportional }"
            v-b-tooltip.hover.nofade="toolTipDelay"
            :title="tooltipText(4)">{{ displayTextConditional(4) }}</div>
    </div>
    <div v-if="topdown" v-bind:class="{ vgrad: proportional, vgradf: !proportional }">
      <div  class="hi"
            v-bind:class="{ fs: smallFont, fl: !smallFont, ph5: proportional, phf: !proportional }"
            v-b-tooltip.hover.nofade="toolTipDelay"
            :title="tooltipText(4)">{{ displayTextConditional(4) }}</div>
      <div  class="hi"
            v-bind:class="{ fs: smallFont, fl: !smallFont, ph4: proportional, phf: !proportional }"
            v-b-tooltip.hover.nofade="toolTipDelay"
            :title="tooltipText(3)">{{ displayTextConditional(3) }}</div>
      <div  class="hi"
            v-bind:class="{ fs: smallFont, fl: !smallFont, ph3: proportional, phf: !proportional }"
            v-b-tooltip.hover.nofade="toolTipDelay"
            :title="tooltipText(2)">{{ displayTextConditional(2) }}</div>
      <div  class="hi"
            v-bind:class="{ fs: smallFont, fl: !smallFont, ph2: proportional, phf: !proportional }"
            v-b-tooltip.hover.nofade="toolTipDelay"
            :title="tooltipText(1)">{{ displayTextConditional(1) }}</div>
      <div  class="hi"
            v-bind:class="{ fs: smallFont, fl: !smallFont, ph1: proportional, phf: !proportional }"
            v-b-tooltip.hover.nofade="toolTipDelay"
            :title="tooltipText(0)">{{ displayTextConditional(0) }}</div>
    </div>
  </div>
</template>

<script>
import AppConfig from '@/mixins/AppConfig-APP_TARGET';
import PorscheScale from '@/mixins/PorscheScale';

export default {
  name: 'Scale',

  mixins: [ AppConfig, PorscheScale ],

  // data() {
  //   return {
  //     options: [
  //       { key: 'Webportal.Porsche.Unacceptable', numbers: '0-34%'},
  //       { key: 'Webportal.Porsche.Insufficient', numbers: '35-59%'},
  //       { key: 'Webportal.Porsche.ToBeOptimized', numbers: '60-74%'},
  //       { key: 'Webportal.Porsche.Good', numbers: '75-90%'},
  //       { key: 'Webportal.Porsche.Excellent', numbers: '91-100%'}
  //     ]
  //   };
  // },

  props: {
    proportional:  { type: Boolean, default: true },
    topdown:  { type: Boolean, default: false },
    smallFont:  { type: Boolean, default: false },
    showText:  { type: Boolean, default: false }
  },

  // methods: {
  //   tooltipText(index) {
  //     return this.options[index].numbers  + ' ' + this.$t(this.options[index].key);
  //   },

  //   displayText(index) {
  //     if (this.showText) {
  //       return this.options[index].numbers;
  //     }
  //   }

};

</script>


<style scoped>

.pwf { width: 20%; }
.pw1 { width: 35%; }
.pw2 { width: 25%; }
.pw3 { width: 15%; }
.pw4 { width: 15%; }
.pw5 { width: 10%; }

.phf { height: 20%; }
.ph5 { height: 13%; }
.ph4 { height: 16%; }
.ph3 { height: 20%; }
.ph2 { height: 30%; }
.ph1 { height: 11%; }

.wi {
  height: 100%;
  float: left;
  color: #222;
  text-shadow:
  -.25px -.25px 0 #666,
  .25px -.25px 0 #666,
  -.25px .25px 0 #666,
  .25px .25px 0 #666;
}

.fl {
  font-size: 11px;
}
.fs {
  font-size: 9px;
}

.hi {
  /* padding-top: 2px; */
  color: #222;
  text-align: center;
  line-height: 0.5rem;
  text-shadow:
  -.25px -.25px 0 #666,
  .25px -.25px 0 #666,
  -.25px .25px 0 #666,
  .25px .25px 0 #666;
}
.hgrad {
  border-radius: 3px;
  height: 100%;
  width: 100%;
  background: linear-gradient(90deg, #ff201c 34%, #f7850E 34%, #f7850E 59%, #FDF804 59%, #FDF804 74%, #96E524 74%, #96E524 90%, #0C891D 90%);
}
.hgradf{
  border-radius: 3px;
  height: 100%;
  width: 100%;
  background: linear-gradient(90deg, #ff201c 20%, #f7850E 20%, #f7850E 40%, #FDF804 40%, #FDF804 60%, #96E524 60%, #96E524 80%, #0C891D 80%);
}

.vgrad {
  border-radius: 3px;
  height: 100%;
  max-width: 155px;
  width: 100%;
  background: linear-gradient(180deg, #0C891D 10%, #96E524 10%, #96E524 26%, #FDF804 26%, #FDF804 41%, #f7850E 41%, #f7850E 66%, #ff201c 66%);
}
.vgradf{
  border-radius: 3px;
  height: 100%;
  width: 100%;
  background: linear-gradient(180deg, #0C891D 20%, #96E524 20%, #96E524 40%, #FDF804 40%, #FDF804 60%, #f7850E 60%, #f7850E 80%, #ff201c 80%);
}

</style>
